<main>
    <section [style.background-color]="mServ.menu.couleurGauche | couleur" class="contenu">
        <h1>{{ mServ.menu['titre_'+mServ.langue] }}</h1>
        <article *ngFor="let a of mServ.pages[mServ.menu.chemin]">
            <h2>{{ a.titre }}</h2>
            <blockquote *ngIf=" a.intro ">{{ a.intro }}</blockquote>
            <p class="cache">{{ a.contenu }}</p>
            <button (click)="toolsServ.showArticle(a)">{{ mServ.getTraduction('suite') }}</button>
            <h3 *ngIf="a.fichiers && a.fichiers.length > 0">{{ mServ.getTraduction('fichiers') }}</h3>
            <ul *ngIf="a.fichiers && a.fichiers.length > 0">
                <li *ngFor="let f of a.fichiers">
                    <a *ngIf="f.fichiers.url" [href]="f.fichiers.url" target="_blank"><i class="fas fa-paperclip"></i> {{ f.titre }} ({{ f.fichiers.ext }})</a>
                    <a *ngIf="f.lien" [href]="f.lien" target="_blank"><i class="fas fa-paperclip"></i> {{ f.titre }}</a>
                </li>
            </ul>
        </article>
    </section>
    <section [style.background-color]="mServ.menu.couleurDroite | couleur" [style.background-image]="'url(' + (mServ.menu.medias[0].url) + ')'" class="img">
    </section>
</main>
<app-plus [infos]="toolsServ.article" *ngIf="toolsServ.article"></app-plus>